import http from './http.js';
import httpBuy from './httpBuy.js';

// 查询订单详情
export const getPaymentInfo = async (data) => await http.post('/cashier/payment',data)
// 校验订单是否支付完成
export const cashierCheck = async (data) => await http.post('/cashier/check',data)
// 虚拟币获取金额和地址
export const getPayAmountAndUrl = async (data) => await http.post('/cashier/forward',data)
// 保存费率
export const rate = async (data) => await http.post('/cashier/rate',data)
// 补充用户信息以及订单信息
export const fillPaymentInfo = async (data) => await http.post('/cashier/fill/payment', data)
// 获取PSE银行列表
export const getBankCodeList = async (data) => await http.get('/common/cop/pse/banks' + (data?.pay_route_id == undefined ? '' : '?pay_route_id=' + data?.pay_route_id), data)
// 获取渠道列表
export const getOrgInfo = async (data) => await http.post('/cashier/methods', data)
// 获取银行列表
export const getInstitutionList = async (data) => await http.get('/common/institution/list?currency=' + data.currency + '&type=' + data.type, data)
// 埋点接口
export const saveTrack = (data) => http.post('/cashier/track', data)

// 快捷收银台配置
export const getQuickPayConfig = async (token) => await http.get('/cashier/quick-pay/config?token=' + encodeURIComponent(token))
// 快捷收银台创建订单
export const createQuickPayOrder = async (data) => await http.post('/cashier/quick-pay/order', data)


// httpBuy 第三方接口
export const  getAmountRange = async (data) => await httpBuy.get('/widget/getAmountRange',data)

export const  list = async (data) => await httpBuy.post('/widget/list',data)

export const  config = async (data) => await httpBuy.get('/widget/config',data)

export const  checkSmallAmtTip = async (data) => await httpBuy.get('/widget/checkSmallAmtTip',data)

export const  placeOrder = async (data) => await httpBuy.post('/widget/placeOrder',data)

export const  paymentMethods = async (data) => await httpBuy.post('/widget/paymentMethods',data)


